export const countries = [
  {
    name: 'United States',
    value: 'US',
    countryPhoneCode: '+1',
  },
  {
    name: 'Other',
    value: 'other',
    countryPhoneCode: null,
  },
];
